import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { useViewportUtilities } from "@/utils/viewport-utilities";
import { useAnchorEvents } from "@/utils/anchor-events";
import Player from "@vimeo/player";
import { useAppStore } from "@/stores/app";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const appStore = useAppStore();

useViewportUtilities();

useAnchorEvents();

onMounted(() => {
    const unsappedElements = document.querySelectorAll(".unsnapped");

    unsappedElements.forEach((element) => {
        element.classList.add("snapped");
    });

    const iframe = document.querySelector('iframe[src*="vimeo"]') as HTMLIFrameElement;
    if (iframe) {
        const player = new Player(iframe);

        player.on("play", () => {
            iframe.classList.remove("opacity-0");
        });
    }
});

const maybeDownloadBrochure = (target: string) => {
    const targetElement = document.querySelector("#download-brochure-button");

    if (targetElement) {
        // @ts-ignore
        targetElement.click();
    }
};

const generalButtonClick = (event: any) => {
    if (!event || !event.target || !event.target.baseURI) {
        return;
    }

    const url = new URL(event.target.closest("a").href);
    const urlParams = new URLSearchParams(url.search);

    const project = urlParams.get("project");
    if (!project) {
        return;
    }

    event.preventDefault();

    appStore.project = "";

    if (url.hash) {
        var anchor: any = document.querySelector(url.hash);
        anchor.scrollIntoView();
    }

    appStore.project = project;
};

const __returned__ = { appStore, maybeDownloadBrochure, generalButtonClick, onMounted, useViewportUtilities, useAnchorEvents, Player, useAppStore }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})